import { Parser, Lexer, createToken, tokenMatcher } from 'chevrotain';
import _ from 'lodash';
const Keyword = createToken({ name: 'Keyword', pattern: Lexer.NA });
const Primitive = createToken({ name: 'Primitive', pattern: Lexer.NA });
const WhiteSpace = createToken({ name: 'WhiteSpace', pattern: /\s+/, group: Lexer.SKIPPED });
const SinglelineComment = createToken({ name: 'SinglelineComment', pattern: /\/\/[^\n|\r\n?]*/, group: Lexer.SKIPPED });
const MultiLineComment = createToken({
    name: 'MultiLineComment',
    pattern: /\/\*[^*]*\*+([^/*][^*]*\*+)*\//,
    group: Lexer.SKIPPED,
    line_breaks: true,
});
const Dot = createToken({ name: 'Dot', pattern: /\./ });
const Hash = createToken({ name: 'Hash', pattern: /#/ });
const Comma = createToken({ name: 'Comma', pattern: /,/ });
const LCurly = createToken({ name: 'LCurly', pattern: /{/ });
const RCurly = createToken({ name: 'RCurly', pattern: /}/ });
const LParen = createToken({ name: 'LParen', pattern: /\(/ });
const RParen = createToken({ name: 'RParen', pattern: /\)/ });
const LSquare = createToken({ name: 'LSquare', pattern: /\[/ });
const RSquare = createToken({ name: 'RSquare', pattern: /]/ });
const LAngle = createToken({ name: 'LAngle', pattern: /</ });
const RAngle = createToken({ name: 'RAngle', pattern: />/ });
const Equal = createToken({ name: 'Equal', pattern: /=/ });
const Colon = createToken({ name: 'Colon', pattern: /:/ });
const SemiColon = createToken({ name: 'SemiColon', pattern: /;/ });
const ExclMark = createToken({ name: 'ExclMark', pattern: /!/ });
const Identifier = createToken({ name: 'Identifier', pattern: /\w+/ });
const Num = createToken({ name: 'Num', pattern: /[0-9]*\.[0-9]+|[0-9]+/, categories: Primitive });
const Null = createToken({ name: 'Null', pattern: /null/, longer_alt: Identifier, categories: Primitive });
const False = createToken({ name: 'False', pattern: /false/, longer_alt: Identifier, categories: Primitive });
const True = createToken({ name: 'True', pattern: /true/, longer_alt: Identifier, categories: Primitive });
const SingleQuote = createToken({
    name: 'SingleQuote',
    pattern: /'(:?[^\\'\n\r]+|\\(:?[bfnrtv'\\/]|u[0-9a-fA-F]{4}))*'/,
    categories: Primitive,
});
const DoubleQuote = createToken({
    name: 'DoubleQuote',
    pattern: /"(:?[^\\"\n\r]+|\\(:?[bfnrtv"\\/]|u[0-9a-fA-F]{4}))*"/,
    categories: Primitive,
});
const Var = createToken({ name: 'Var', pattern: /var/, longer_alt: Identifier, categories: Keyword });
const Static = createToken({ name: 'Static', pattern: /static/, longer_alt: Identifier, categories: Keyword });
const Func = createToken({ name: 'Func', pattern: /function/, longer_alt: Identifier, categories: Keyword });
const Type = createToken({ name: 'Type', pattern: /type/, longer_alt: Identifier, categories: Keyword });
const New = createToken({ name: 'New', pattern: /new/, longer_alt: Identifier, categories: Keyword });
const Return = createToken({ name: 'Return', pattern: /return/, longer_alt: Identifier, categories: Keyword });
const Private = createToken({ name: 'Private', pattern: /private/, longer_alt: Identifier, categories: Keyword });
const If = createToken({ name: 'If', pattern: /if/, longer_alt: Identifier, categories: Keyword });
const Then = createToken({ name: 'Then', pattern: /then/, longer_alt: Identifier, categories: Keyword });
const Else = createToken({ name: 'Else', pattern: /else/, longer_alt: Identifier, categories: Keyword });
LParen.LABEL = "'('";
RParen.LABEL = "')'";
LCurly.LABEL = "'{'";
RCurly.LABEL = "'}'";
LSquare.LABEL = "'['";
RSquare.LABEL = "']'";
LAngle.LABEL = "'<'";
RAngle.LABEL = "'>'";
Dot.LABEL = "'.'";
Hash.LABEL = "'#'";
Comma.LABEL = "','";
Equal.LABEL = "'='";
SinglelineComment.LABEL = "'single comment'";
MultiLineComment.LABEL = "'multiline comment'";
New.LABEL = "'new'";
Colon.LABEL = "':'";
SemiColon.LABEL = "';'";
ExclMark.LABEL = "'!'";
export const tokens = [
    WhiteSpace,
    SinglelineComment,
    MultiLineComment,
    Var,
    Func,
    Type,
    Null,
    New,
    Private,
    Static,
    False,
    True,
    Return,
    If,
    Then,
    Else,
    Num,
    Identifier,
    SingleQuote,
    DoubleQuote,
    Equal,
    Colon,
    LParen,
    RParen,
    RCurly,
    LCurly,
    LSquare,
    RSquare,
    LAngle,
    RAngle,
    Dot,
    Hash,
    Comma,
    SemiColon,
    ExclMark,
];
export const lexer = new Lexer(tokens);
export function findTokenAtPos(tkns, pos) {
    return tkns.find((t) => t.startLine <= pos.line &&
        t.endLine >= pos.line &&
        t.startColumn <= pos.character &&
        t.endColumn >= pos.character);
}
export class GreyCatParser extends Parser {
    constructor(input) {
        super(input, tokens, {
            recoveryEnabled: false,
            outputCst: true,
        });
        this.greycat = this.RULE('greycat', () => {
            this.MANY(() => this.SUBRULE(this.stmt));
        });
        this.stmt = this.RULE('stmt', () => {
            this.OR([
                { ALT: () => this.SUBRULE(this.funcCall) },
                { ALT: () => this.SUBRULE(this.funcDecl) },
                { ALT: () => this.SUBRULE(this.typeDecl) },
                { ALT: () => this.SUBRULE(this.assign) },
                { ALT: () => this.SUBRULE(this.varDecl) },
                { ALT: () => this.SUBRULE(this.block) },
            ]);
            this.OPTION(() => this.CONSUME(SemiColon));
        });
        this.funcStmts = this.RULE('funcStmts', () => {
            this.MANY(() => this.SUBRULE(this.funcStmt));
        });
        this.funcStmt = this.RULE('funcStmt', () => {
            this.OR([
                { ALT: () => this.SUBRULE(this.ifStmt) },
                { ALT: () => this.SUBRULE(this.return) },
                { ALT: () => this.SUBRULE(this.funcDecl) },
                { ALT: () => this.SUBRULE(this.funcCall) },
                { ALT: () => this.SUBRULE(this.assign) },
                { ALT: () => this.SUBRULE(this.varDecl) },
                { ALT: () => this.SUBRULE(this.block) },
            ]);
            this.OPTION(() => this.CONSUME(SemiColon));
        });
        this.block = this.RULE('block', () => {
            this.CONSUME(LCurly);
            this.SUBRULE(this.funcStmts);
            this.CONSUME(RCurly);
        });
        this.ifStmt = this.RULE('ifStmt', () => {
            this.CONSUME(If);
            this.CONSUME(LParen);
            this.SUBRULE(this.binaryExpr);
            this.CONSUME(RParen);
            this.SUBRULE(this.thenStmt);
        });
        this.thenStmt = this.RULE('thenStmt', () => {
            this.SUBRULE(this.block);
            this.OPTION(() => this.SUBRULE(this.elseStmt));
        });
        this.elseStmt = this.RULE('elseStmt', () => {
            this.CONSUME(Else);
            this.SUBRULE(this.block);
        });
        this.funcDecl = this.RULE('funcDecl', () => {
            this.OPTION(() => {
                this.CONSUME(Func);
                this.CONSUME(Identifier);
            });
            this.CONSUME1(LParen);
            this.SUBRULE1(this.paramsDecl);
            this.CONSUME1(RParen);
            this.CONSUME2(LCurly);
            this.SUBRULE2(this.funcStmts);
            this.CONSUME2(RCurly);
        });
        this.paramsDecl = this.RULE('paramsDecl', () => {
            this.OPTION(() => {
                this.SUBRULE(this.paramDecl);
                this.MANY(() => {
                    this.CONSUME(Comma);
                    this.SUBRULE1(this.paramDecl);
                });
            });
        });
        this.paramDecl = this.RULE('paramDecl', () => {
            this.CONSUME(Identifier, { LABEL: 'name' });
            this.CONSUME(Colon);
            this.CONSUME1(Identifier, { LABEL: 'type' });
        });
        this.typeDecl = this.RULE('typeDecl', () => {
            this.CONSUME(Type);
            this.CONSUME(Identifier);
            this.CONSUME(LCurly);
            this.MANY(() => this.SUBRULE(this.typeStmt));
            this.CONSUME(RCurly);
        });
        this.typeStmt = this.RULE('typeStmt', () => {
            this.OPTION(() => {
                this.OR([
                    {
                        ALT: () => {
                            this.CONSUME(Private);
                            this.OPTION1(() => this.CONSUME(Static));
                        },
                    },
                    {
                        ALT: () => {
                            this.CONSUME1(Static);
                            this.OPTION2(() => this.CONSUME1(Private));
                        },
                    },
                ]);
            });
            this.OR1([{ ALT: () => this.SUBRULE(this.funcDecl) }, { ALT: () => this.SUBRULE(this.attDecl) }]);
            this.OPTION3(() => this.CONSUME(SemiColon));
        });
        this.attDecl = this.RULE('attDecl', () => {
            this.CONSUME(Identifier, { LABEL: 'name' });
            this.CONSUME(Colon);
            this.CONSUME1(Identifier, { LABEL: 'type' });
            this.OPTION(() => {
                this.CONSUME(LAngle);
                this.CONSUME2(Identifier);
                this.CONSUME(RAngle);
            });
            this.OPTION1(() => {
                this.CONSUME(Equal);
                this.SUBRULE(this.expr);
            });
        });
        this.funcCall = this.RULE('funcCall', () => {
            this.SUBRULE(this.qName);
            this.CONSUME(LParen);
            this.SUBRULE(this.params);
            this.CONSUME(RParen);
        });
        this.params = this.RULE('params', () => {
            this.OPTION(() => {
                this.SUBRULE(this.param);
                this.MANY(() => {
                    this.CONSUME(Comma);
                    this.SUBRULE1(this.param);
                });
            });
        });
        this.param = this.RULE('param', () => {
            this.OPTION(() => {
                this.CONSUME(Identifier);
                this.CONSUME(Colon);
            });
            this.SUBRULE(this.expr);
        });
        this.assign = this.RULE('assign', () => {
            this.SUBRULE(this.qName);
            this.CONSUME(Equal);
            this.SUBRULE(this.expr);
        });
        this.return = this.RULE('return', () => {
            this.CONSUME(Return);
            this.SUBRULE(this.expr);
        });
        this.varDecl = this.RULE('varDecl', () => {
            this.CONSUME(Var);
            this.CONSUME(Identifier);
            this.OPTION(() => {
                this.CONSUME(Equal);
                this.SUBRULE(this.expr);
            });
        });
        this.newDecl = this.RULE('newDecl', () => {
            this.CONSUME(New);
            this.CONSUME(Identifier);
            this.OPTION(() => this.SUBRULE(this.inlineDecl));
        });
        this.inlineDecl = this.RULE('inlineDecl', () => {
            this.CONSUME(LCurly);
            this.SUBRULE(this.params);
            this.CONSUME(RCurly);
        });
        this.typedInlineDecl = this.RULE('typedInlineDecl', () => {
            this.CONSUME(Identifier);
            this.SUBRULE(this.inlineDecl);
        });
        this.expr = this.RULE('expr', () => {
            this.OR([
                { ALT: () => this.CONSUME(Null) },
                { ALT: () => this.CONSUME(False) },
                { ALT: () => this.CONSUME(True) },
                { ALT: () => this.CONSUME(Num) },
                { ALT: () => this.SUBRULE(this.funcDecl) },
                { ALT: () => this.SUBRULE(this.newDecl) },
                { ALT: () => this.SUBRULE(this.inlineDecl) },
                { ALT: () => this.SUBRULE(this.typedInlineDecl) },
                { ALT: () => this.SUBRULE(this.arrayDecl) },
                { ALT: () => this.SUBRULE(this.typedArrayDecl) },
                { ALT: () => this.SUBRULE(this.funcCall) },
                { ALT: () => this.SUBRULE(this.stringLiteral) },
                { ALT: () => this.SUBRULE(this.qName) },
                { ALT: () => this.SUBRULE(this.hashRef) },
            ]);
        });
        this.binaryExpr = this.RULE('binaryExpr', () => {
            this.SUBRULE(this.expr, { LABEL: 'lhs' });
            this.OPTION(() => {
                this.OR([
                    {
                        ALT: () => {
                            this.CONSUME(Equal);
                            this.CONSUME1(Equal);
                        },
                        NAME: 'equalTo',
                    },
                    {
                        ALT: () => {
                            this.CONSUME(ExclMark);
                            this.CONSUME2(Equal);
                        },
                        NAME: 'notEqualTo',
                    },
                    {
                        ALT: () => {
                            this.CONSUME(RAngle);
                            this.CONSUME3(Equal);
                        },
                        NAME: 'greaterThan',
                    },
                    {
                        ALT: () => {
                            this.CONSUME(LAngle);
                            this.CONSUME4(Equal);
                        },
                        NAME: 'lesserThan',
                    },
                ]);
                this.SUBRULE1(this.expr, { LABEL: 'rhs' });
            });
        });
        this.arrayDecl = this.RULE('arrayDecl', () => {
            this.CONSUME(LSquare);
            this.OPTION(() => {
                this.SUBRULE(this.expr);
                this.MANY(() => {
                    this.CONSUME(Comma);
                    this.SUBRULE1(this.expr);
                });
            });
            this.CONSUME(RSquare);
        });
        this.typedArrayDecl = this.RULE('typedArrayDecl', () => {
            this.CONSUME(Identifier);
            this.SUBRULE(this.arrayDecl);
        });
        this.stringLiteral = this.RULE('stringLiteral', () => {
            this.OR([
                { ALT: () => this.CONSUME(SingleQuote, { LABEL: 'value' }) },
                { ALT: () => this.CONSUME(DoubleQuote, { LABEL: 'value' }) },
            ]);
        });
        this.hashRef = this.RULE('hashRef', () => {
            this.CONSUME(Hash);
            this.CONSUME(Identifier);
        });
        this.qName = this.RULE('qName', () => {
            this.CONSUME(Identifier);
            this.MANY(() => {
                this.CONSUME(Dot);
                this.CONSUME1(Identifier);
            });
        });
        this.performSelfAnalysis();
    }
}
export const parser = new GreyCatParser([]);
export function suggest(text, pos, symbolTable = []) {
    const lexResult = lexer.tokenize(text);
    if (lexResult.errors.length > 0) {
        throw new Error('sad sad panda, lexing errors detected');
    }
    const tokenAtPos = findTokenAtPos(lexResult.tokens, pos);
    let partialSuggestionMode = false;
    let assistanceTokenVector = lexResult.tokens;
    if (tokenAtPos !== undefined &&
        (tokenMatcher(tokenAtPos, Identifier) || tokenMatcher(tokenAtPos, Keyword)) &&
        /\w/.test(text[text.length - 1])) {
        assistanceTokenVector = _.dropRight(assistanceTokenVector);
        partialSuggestionMode = true;
    }
    const syntacticSuggestions = parser.computeContentAssist('greycat', assistanceTokenVector);
    let finalSuggestions = [];
    for (let i = 0; i < syntacticSuggestions.length; i++) {
        const currSyntaxSuggestion = syntacticSuggestions[i];
        const currTokenType = currSyntaxSuggestion.nextTokenType;
        const currRuleStack = currSyntaxSuggestion.ruleStack;
        const lastRuleName = _.last(currRuleStack);
        if (Keyword.categoryMatchesMap[currTokenType.tokenTypeIdx]) {
            const tkType = currTokenType.PATTERN;
            finalSuggestions.push(tkType.source);
        }
        else if (currTokenType === Identifier) {
            if (_.includes(['funcDecl'], lastRuleName)) {
            }
            else if (_.includes(['qName', 'hashRef', 'funcCall'], lastRuleName)) {
                finalSuggestions = finalSuggestions.concat(symbolTable);
            }
            else {
            }
        }
        else {
        }
    }
    if (partialSuggestionMode) {
        finalSuggestions = _.filter(finalSuggestions, (currSuggestion) => {
            return _.startsWith(currSuggestion, tokenAtPos.image);
        });
    }
    return _.uniq(finalSuggestions);
}
//# sourceMappingURL=grammar.js.map